module.exports = __webpack_public_path__ + "static/img/13.635e38b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/5/zh/13.png
// module id = zMJB
// module chunks = 0